export function BrokenPage() {
	return (
		<svg
			width="236"
			height="242"
			viewBox="0 0 236 242"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clip-path="url(#clip0_2273_29621)">
				<rect width="236" height="242" fill="white" />
				<path
					d="M86.0879 31.9121C92.523 31.9121 97.7397 26.6916 97.7397 20.2517C97.7397 13.8118 92.523 8.59131 86.0879 8.59131C79.6527 8.59131 74.436 13.8118 74.436 20.2517C74.436 26.6916 79.6527 31.9121 86.0879 31.9121Z"
					fill="#FFF7B2"
				/>
				<path
					d="M191.555 91.2753V118.474H224.688L234.006 127.799V91.531C234.006 91.531 192.773 91.2753 191.551 91.271L191.555 91.2753Z"
					fill="#FFFACC"
				/>
				<path
					d="M234.01 139.008V166.207H200.878L191.56 175.532V139.264C191.56 139.264 233.499 138.897 234.015 139.004L234.01 139.008Z"
					fill="#FFEC44"
				/>
				<path
					d="M20.4246 98.8095H1.84619V7.76758H9.43242L8.70468 91.8837H19.9592L20.4246 98.8095Z"
					fill="#F4C02F"
				/>
				<path
					d="M19.7812 60.1318V168.892L50.7608 138.139L78.5755 146.055L86.039 116.659L128.552 127.511V85.6814L169.255 60.1318H19.7812ZM31.772 72.9849C27.4606 72.9849 27.469 66.2961 31.772 66.2961C36.0749 66.2961 36.0749 72.9849 31.772 72.9849ZM43.7246 72.9849C39.4132 72.9849 39.4216 66.2961 43.7246 66.2961C48.0275 66.2961 48.0275 72.9849 43.7246 72.9849ZM55.4911 72.9849C51.1797 72.9849 51.1881 66.2961 55.4911 66.2961C59.794 66.2961 59.794 72.9849 55.4911 72.9849Z"
					fill="#FFFACC"
				/>
				<path
					d="M116.033 183.806H27.7441L58.6898 154.013L86.1068 162.428L93.9765 132.567L136.871 143.698L136.325 101.623L177.315 76.6531V183.869H168.768L168.438 180.878L116.092 181.026L116.033 183.806Z"
					fill="#FFFACC"
				/>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M18.9395 60.1318L19.7857 59.2856H169.255L169.705 60.8484L129.399 86.1493V127.511L128.343 128.331L86.6509 117.689L79.3959 146.263L78.344 146.868L51.0099 139.088L20.3818 169.493L18.9395 168.892V60.1318ZM20.6319 60.978V166.86L50.169 137.538L50.9969 137.325L77.9698 145.002L85.219 116.451L86.2485 115.839L127.706 126.422V85.6814L128.103 84.9648L166.315 60.978H20.6319Z"
					fill="#0C0D0D"
				/>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M140.082 79.2183H20.2344V77.2183H140.082V79.2183Z"
					fill="#0C0D0D"
				/>
				<circle cx="149" cy="214.5" r="17.5" fill="#FFF7B2" />
				<path
					d="M133.147 28.198L133.994 27.3518H157.89V29.0441H134.84V60.4026H133.147V28.198Z"
					fill="#0C0D0D"
				/>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M27.1899 69.5706C27.1899 67.0121 29.2641 64.9379 31.8228 64.9379C34.3816 64.9379 36.4558 67.0121 36.4558 69.5706C36.4558 72.1292 34.3816 74.2033 31.8228 74.2033C29.2641 74.2033 27.1899 72.1292 27.1899 69.5706ZM31.8228 66.6302C30.1988 66.6302 28.8823 67.9467 28.8823 69.5706C28.8823 71.1946 30.1988 72.511 31.8228 72.511C33.4469 72.511 34.7634 71.1946 34.7634 69.5706C34.7634 67.9467 33.4469 66.6302 31.8228 66.6302Z"
					fill="#0C0D0D"
				/>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M39.0367 69.5706C39.0367 67.0121 41.111 64.9379 43.6697 64.9379C46.2284 64.9379 48.3027 67.0121 48.3027 69.5706C48.3027 72.1292 46.2284 74.2033 43.6697 74.2033C41.111 74.2033 39.0367 72.1292 39.0367 69.5706ZM43.6697 66.6302C42.0457 66.6302 40.7292 67.9467 40.7292 69.5706C40.7292 71.1946 42.0457 72.511 43.6697 72.511C45.2937 72.511 46.6103 71.1946 46.6103 69.5706C46.6103 67.9467 45.2937 66.6302 43.6697 66.6302Z"
					fill="#0C0D0D"
				/>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M55.5166 64.9379C52.9579 64.9379 50.8836 67.0121 50.8836 69.5706C50.8836 72.1292 52.9579 74.2033 55.5166 74.2033C58.0753 74.2033 60.1495 72.1292 60.1495 69.5706C60.1495 67.0121 58.0753 64.9379 55.5166 64.9379ZM52.576 69.5706C52.576 67.9467 53.8925 66.6302 55.5166 66.6302C57.1406 66.6302 58.4571 67.9467 58.4571 69.5706C58.4571 71.1946 57.1406 72.511 55.5166 72.511C53.8925 72.511 52.576 71.1946 52.576 69.5706Z"
					fill="#0C0D0D"
				/>
				<path
					d="M137.177 102.095L137.717 143.687L136.658 144.517L94.58 133.598L86.9251 162.643L85.8585 163.237L58.9178 154.968L29.8431 182.96H116.033V184.652H59.3922V225.242H116.295V226.934H58.546L57.6998 226.088V184.652H27.7441L27.1572 183.196L58.1029 153.403L58.9381 153.204L85.513 161.36L93.1583 132.351L94.1891 131.748L136.01 142.6L135.479 101.634L135.885 100.9L176.875 75.9304L178.161 76.653V183.869L177.315 184.715H168.768V183.023H176.469V78.1593L137.177 102.095Z"
					fill="#0C0D0D"
				/>
				<path
					d="M211.464 27.3518H187.634V29.0441H210.617V91.1095H212.31V28.198L211.464 27.3518Z"
					fill="#0C0D0D"
				/>
				<path d="M212.31 117.882V139.302H210.617V117.882H212.31Z" fill="#0C0D0D" />
				<path
					d="M212.31 220.563V166.248H210.617V219.716H176.067V221.409H211.464L212.31 220.563Z"
					fill="#0C0D0D"
				/>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M176.841 95.0498H148.76V93.0498H176.841V95.0498Z"
					fill="#0C0D0D"
				/>
				<path
					d="M172.822 43.2766C181.299 43.2766 188.172 36.4045 188.172 27.9274C188.172 19.4502 181.299 12.5781 172.822 12.5781C164.344 12.5781 157.472 19.4502 157.472 27.9274C157.472 36.4045 164.344 43.2766 172.822 43.2766Z"
					fill="#FFEC44"
				/>
				<path
					d="M172.088 34.9319L179.277 21.7319L177.791 20.9226L171.281 32.8752L167.824 27.5511L166.405 28.4727L170.636 34.9881L172.088 34.9319Z"
					fill="#0C0D0D"
				/>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M156.626 27.9273C156.626 18.9829 163.877 11.7319 172.822 11.7319C181.767 11.7319 189.018 18.9829 189.018 27.9273C189.018 36.8718 181.767 44.1227 172.822 44.1227C163.877 44.1227 156.626 36.8718 156.626 27.9273ZM172.822 13.4242C164.812 13.4242 158.318 19.9175 158.318 27.9273C158.318 35.9372 164.812 42.4304 172.822 42.4304C180.832 42.4304 187.326 35.9371 187.326 27.9273C187.326 19.9175 180.832 13.4242 172.822 13.4242Z"
					fill="#0C0D0D"
				/>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M191.341 91.2535L191.695 90.4031C192.304 90.4052 202.851 90.4697 213.242 90.5337C218.439 90.5657 223.597 90.5976 227.457 90.6214L233.876 90.6612C233.876 90.6612 233.877 90.6612 233.871 91.5073L233.876 90.6612L234.718 91.5073V127.511L233.273 128.109L224.263 119.1H191.697L190.85 118.254V91.2535H191.341ZM192.543 92.1V117.408H224.614L225.212 117.656L233.025 125.468V92.3482L227.446 92.3137C223.587 92.2898 218.428 92.258 213.232 92.226C204.338 92.1712 195.336 92.1161 192.543 92.1Z"
					fill="#0C0D0D"
				/>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M148.938 196.913C139.264 196.913 131.421 204.755 131.421 214.428C131.421 224.102 139.264 231.943 148.938 231.943C158.612 231.943 166.454 224.102 166.454 214.428C166.454 204.755 158.612 196.913 148.938 196.913ZM133.114 214.428C133.114 205.689 140.199 198.605 148.938 198.605C149.054 198.605 149.17 198.606 149.286 198.609L146.828 214.583L147.664 215.558H164.722C164.143 223.769 157.297 230.251 148.938 230.251C140.199 230.251 133.114 223.167 133.114 214.428ZM149.005 211.561L150.979 198.735C153.29 199.033 155.445 199.829 157.333 201.013L149.005 211.561ZM149.342 213.865H164.752C164.584 209.048 162.262 204.778 158.719 201.989L149.342 213.865Z"
					fill="#0C0D0D"
				/>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M114.933 180.878L115.779 180.032H168.439L169.285 180.878V186.932H175.267L176.114 187.778V241.082L175.267 241.928H122.608L121.762 241.082V187.778L122.608 186.932H167.592V181.724H116.626V233.335H121.732V235.028H115.779L114.933 234.182V180.878ZM167.592 188.675V188.625H123.454V240.236H174.421V188.625H169.285V188.675H167.592Z"
					fill="#0C0D0D"
				/>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M234.051 137.805L234.302 138.638H234.722V165.639L233.876 166.485H201.309L192.299 175.494L190.855 174.896V138.892L191.693 138.046L191.701 138.892C191.697 138.465 191.695 138.253 191.694 138.148C191.694 138.113 191.694 138.09 191.694 138.075C191.694 138.046 191.693 138.046 191.693 138.046L193.485 138.03C194.625 138.021 196.255 138.007 198.212 137.991C202.127 137.958 207.351 137.916 212.592 137.877C217.833 137.838 223.09 137.803 227.069 137.783C229.059 137.774 230.73 137.768 231.921 137.768C232.515 137.768 232.992 137.77 233.33 137.773C233.498 137.775 233.635 137.777 233.735 137.779C233.756 137.78 233.776 137.78 233.795 137.781C233.822 137.782 233.847 137.783 233.869 137.784L233.872 137.784C233.89 137.785 233.972 137.789 234.051 137.805ZM192.547 172.853V139.731L193.499 139.723C194.64 139.713 196.269 139.699 198.226 139.683C202.14 139.65 207.365 139.608 212.605 139.569C217.845 139.53 223.1 139.495 227.077 139.476C229.066 139.466 230.734 139.461 231.92 139.461C232.36 139.461 232.732 139.462 233.029 139.463V164.793H200.958L200.36 165.04L192.547 172.853ZM233.8 139.475C233.8 139.475 233.796 139.475 233.789 139.475C233.797 139.475 233.8 139.475 233.8 139.475Z"
					fill="#0C0D0D"
				/>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M87.9038 60.1234V44.1946H89.9038V60.1234H87.9038Z"
					fill="#0C0D0D"
				/>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M7.85846 0.846154L8.70466 0H88.9037L89.7499 0.846154V8.24729C94.8395 9.80005 98.5419 14.5327 98.5419 20.13C98.5419 23.832 96.9224 27.1556 94.3532 29.4313V47.2915L92.9963 47.9662L86.3366 42.9254L79.2225 47.9812L77.8861 47.2915V29.4314C75.3169 27.1557 73.6974 23.832 73.6974 20.13C73.6974 13.2698 79.259 7.7085 86.1197 7.7085C86.7788 7.7085 87.426 7.75984 88.0575 7.85874V1.69231H9.55087V91.0377H19.9592V92.73H8.70466L7.85846 91.8838V8.61382H2.69241V97.9634H20.4246V99.6557H1.8462L1 98.8096V7.76766L1.8462 6.92151H7.85846V0.846154ZM79.5785 30.692V45.6521L85.8622 41.1864L86.8631 41.2015L92.6608 45.5898V30.692C90.7611 31.8709 88.5199 32.5516 86.1197 32.5516C83.7194 32.5516 81.4782 31.8709 79.5785 30.692ZM86.1197 9.4008C80.1937 9.4008 75.3898 14.2044 75.3898 20.13C75.3898 26.0556 80.1937 30.8593 86.1197 30.8593C92.0456 30.8593 96.8495 26.0556 96.8495 20.13C96.8495 14.2044 92.0456 9.4008 86.1197 9.4008Z"
					fill="#0C0D0D"
				/>
				<path d="M21.0804 21.3358H65.7093V19.6435H21.0804V21.3358Z" fill="#0C0D0D" />
				<path d="M65.7093 34.8743H21.0804V33.1819H65.7093V34.8743Z" fill="#0C0D0D" />
				<path d="M21.0804 48.4127H65.7093V46.7204H21.0804V48.4127Z" fill="#0C0D0D" />
				<path
					d="M93.5068 29.2219V47.2915L86.3522 41.8762L78.7363 47.2915V29.2219L82.8785 30.6138C84.9813 31.3204 87.2618 31.3204 89.3647 30.6138L93.5068 29.2219Z"
					fill="#0C0D0D"
				/>
				<path
					d="M19.7812 60.1318V78.2226H138.986L169.111 60.1318H19.7812ZM31.7931 72.9426C27.4817 72.9426 27.4902 66.2538 31.7931 66.2538C36.0961 66.2538 36.0961 72.9426 31.7931 72.9426ZM43.6357 72.8368C39.3243 72.8368 39.3328 66.148 43.6357 66.148C47.9387 66.148 47.9387 72.8368 43.6357 72.8368ZM55.4784 72.9426C51.167 72.9426 51.1754 66.2538 55.4784 66.2538C59.7813 66.2538 59.7813 72.9426 55.4784 72.9426Z"
					fill="#0C0D0D"
				/>
				<path d="M149.966 94.0499L176.841 77.533V94.0499H149.966Z" fill="#0C0D0D" />
				<path
					d="M148.248 214.475L158.682 201.448C158.682 201.448 164.618 205.734 165.32 214.475H148.244H148.248Z"
					fill="#0C0D0D"
				/>
			</g>
			<defs>
				<clipPath id="clip0_2273_29621">
					<rect width="236" height="242" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
}
